import { Breadcrumb } from '@progress/kendo-react-layout';
import { KWELLO_ICON, KwelloSvgIcon } from '../icon/KwelloSvgIcon';
import useNavigationMenus from 'common/hooks/useMenus';

export default function ActiveSection() {
  const { currentPageMenuItem } = useNavigationMenus();

  const data = [
    {
      id: currentPageMenuItem?.id,
      text: currentPageMenuItem?.text,
      icon: currentPageMenuItem?.icon && (
        <KwelloSvgIcon
          icon={KWELLO_ICON[currentPageMenuItem?.icon.toUpperCase() as keyof typeof KWELLO_ICON]}
          className="k-svg-icon"
        />
      ),
    },
  ];

  return (
    <div className="kwello-breadcrumb">
      <Breadcrumb data={data} />
    </div>
  );
}
